import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const NavigationControls = ({ 
  currentSlide, 
  totalSlides, 
  onPrevious, 
  onNext, 
  canGoPrevious, 
  canGoNext 
}) => {
  return (
    <>
      {/* Desktop Navigation Arrows */}
      <div className="hidden md:block">
        {/* Previous Arrow */}
        <button
          onClick={onPrevious}
          disabled={!canGoPrevious}
          className={`fixed left-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full shadow-elevation-2 flex items-center justify-center nav-transition z-10 ${
            canGoPrevious 
              ? 'bg-surface border border-border hover:bg-border-light text-text-primary' :'bg-border text-text-secondary cursor-not-allowed'
          }`}
          aria-label="Previous slide"
        >
          <Icon name="ChevronLeft" size={20} />
        </button>

        {/* Next Arrow */}
        <button
          onClick={onNext}
          disabled={!canGoNext}
          className={`fixed right-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full shadow-elevation-2 flex items-center justify-center nav-transition z-10 ${
            canGoNext 
              ? 'bg-surface border border-border hover:bg-border-light text-text-primary' :'bg-border text-text-secondary cursor-not-allowed'
          }`}
          aria-label="Next slide"
        >
          <Icon name="ChevronRight" size={20} />
        </button>
      </div>

      {/* Mobile Navigation Controls */}
      <div className="md:hidden fixed bottom-20 left-0 right-0 flex justify-center space-x-4 z-10">
        <Button
          variant="secondary"
          iconName="ChevronLeft"
          iconPosition="left"
          onClick={onPrevious}
          disabled={!canGoPrevious}
          className="px-6 py-3 shadow-elevation-2"
        >
          Previous
        </Button>
        
        <div className="flex items-center px-4 py-3 bg-surface border border-border rounded-lg shadow-elevation-2">
          <span className="text-sm font-medium text-text-primary">
            {currentSlide} / {totalSlides}
          </span>
        </div>

        <Button
          variant="primary"
          iconName="ChevronRight"
          iconPosition="right"
          onClick={onNext}
          disabled={!canGoNext}
          className="px-6 py-3 shadow-elevation-2"
        >
          Next
        </Button>
      </div>

      {/* Keyboard Navigation Hint */}
      <div className="hidden lg:block fixed bottom-4 left-1/2 -translate-x-1/2 text-xs text-text-secondary bg-surface border border-border rounded px-3 py-1">
        Use ← → arrow keys to navigate
      </div>
    </>
  );
};

export default NavigationControls;